import { AlertTriangle, CheckCircle2 } from 'lucide-react';
import type { ControleFacture } from '../../lib/useCircuitFactures';

/**
 * Contrôles SIRET, RIB, montant, séquences et période d'une facture formateur
 * (TF-402), relus par l'API au jour de la lecture. Ce sont des signaux : ils
 * ne bloquent aucun geste. Le registre « Factures formateurs » et la fenêtre
 * de contrôle les montrent tous deux.
 */
export function ControlesFacture({ controles }: { controles: ControleFacture[] }): JSX.Element {
  return (
    <ul className="space-y-1.5">
      {controles.map((controle) => (
        <li
          key={controle.code}
          className={`flex gap-2 rounded-xl px-3 py-2 text-xs ${
            controle.ok ? 'bg-gray-50 text-codialis-navy' : 'bg-amber-50 text-amber-900'
          }`}
        >
          {controle.ok ? (
            <CheckCircle2 className="mt-px h-4 w-4 shrink-0 text-codialis-teal" aria-hidden="true" />
          ) : (
            <AlertTriangle className="mt-px h-4 w-4 shrink-0 text-amber-700" aria-hidden="true" />
          )}
          <p className="min-w-0 break-words">
            <span className="font-semibold">{controle.libelle}</span>
            <span className="sr-only">{controle.ok ? ', conforme' : ', à contrôler'}</span> · {controle.detail}
          </p>
        </li>
      ))}
    </ul>
  );
}

/** « 2 points à contrôler » */
export function libelleAlertes(alertes: number): string {
  return `${alertes} point${alertes > 1 ? 's' : ''} à contrôler`;
}
